import type {RootStore} from 'stores/rootStore';
import {humanizerV2} from './humanizerV2';

/**
 * A release announcement — the "what's new" modal (Figma DEVELOP 540:7758 / 540:7996) shown
 * once per account, 5 s after a scan's result lands. How to ship one: docs/ANNOUNCEMENTS.md.
 */
export interface Announcement {
    /** Stored on the account once shown and sent with every event as `announcement_id`, so a
     *  new release takes a new id — reusing one would hide it from everyone who saw the old. */
    id: string;
    /** Who it is for, on top of the rule every announcement shares: a signed-in account
     *  (seen state lives on the account), in the app itself (not the widget or a report). */
    audience: (root: RootStore) => boolean;
    /** Optional delivery experiment, evaluated once the popup can actually open, after
     * audience, seen-state, timing and competing-modal checks. False suppresses this page's offer. */
    shouldShow?: (root: RootStore) => boolean;
    /** Fluent keys. */
    copy: {
        eyebrow: string;
        title: string;
        subtitle: string;
        features: string[];
        cta: string;
    };
    /** Under public/: the desktop popup's right panel (373×440) and the phone sheet's hero
     *  (375×360), both at 2×. */
    image: {desktop: string; mobile: string};
    /** The CTA, run after the modal has closed. */
    onCta: (root: RootStore) => void;
}

/** The release's announcement — one at most; null ships none. */
export const ACTIVE_ANNOUNCEMENT: Announcement | null = humanizerV2;
